import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-agent',
    templateUrl: './agent.component.html',
    styleUrls: ['./agent.component.css']
})
export class AgentComponent implements OnInit {
    
    //for disabling div  in production
    constructor(private router: Router, private _location: Location) {
     
    }

    ngOnInit() {
       
    }

   

}